import { useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import styles from './CareersPage.module.css'
import Header from '../../components/Header/Header'
import Footer from '../../components/Footer/Footer'
import { HeaderType } from '../../components/Header/types/Header'
import { FooterType } from '../../components/Footer/types/Footer'
import VacancyItem from '../../components/VacancyItem/VacancyItem'
import { Helmet } from 'react-helmet'
import Icon from '../../components/Icon'
import { api } from '../../utils/api'
import { transformCareersList } from '../../utils/transformers'
import Loader from '../../components/Loader/Loader'

interface Vacancy {
  id: number;
  title: string;
  location: string;
  work_hours: string;
  tasks: string[];
  requirements: string[];
}

export default function CareersPage() {
  const location = useLocation()
  const vacancy = location.state?.vacancy
  const [vacancies, setVacancies] = useState<Vacancy[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const careersData = await api.career.getAll();
        const transformedVacancies = transformCareersList(careersData);
        setVacancies(transformedVacancies);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchData();
  }, []);
  
  const handleShareLink = () => {
    navigator.clipboard.writeText('info@vostokstroy.com')
  };
  
  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Helmet>
        <title>Карьера | Восток Строй</title>
        <meta name="description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="keywords" content="недвижимость, девелопер, Каспийск, новостройки, квартиры" />
        <meta name="author" content="Восток Строй" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://vostokstroy.com/careers" />

        <meta property="og:title" content="Ведущему девелоперу Каспийска — 10 лет" />
        <meta property="og:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta property="og:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" />
        <meta property="og:url" content="https://vostokstroy.com/careers" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Восток Строй" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Карьера | Восток Строй" />
        <meta name="twitter:description" content="Мы начали свой путь в 2014 году и реализовали 9 успешных проектов." />
        <meta name="twitter:image" content="https://vostokstroy.com/open-graphs/main-opengraph.jpg" />

        <link rel="icon" type="image/svg+xml" href="/favicons/main-fav-32x32.svg" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicons/main-fav-16x16.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicons/main-fav-32x32.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/favicons/main-apple-touch-icon-180x180.png" />
        <link rel="icon" type="image/png" sizes="180x180" href="/favicons/main-fav-180x180.png" />
      </Helmet>
      <Header theme={HeaderType.Light} />
      <div className={styles.content}>
        <div className={styles.page_name}>
          <div className={styles.career_preview_card}>
            <div className={styles.career_preview_wrapper}>
              <h2>У&nbsp;нас строят не&nbsp;только дома, но&nbsp;и&nbsp;карьеру</h2>
              <p className='text_body_b1'>
              Мы&nbsp;всегда рады как крутым специалистам, так и&nbsp;перспективным новичкам. Готовы делиться своими знаниями и&nbsp;опытом.
              </p>
            </div>
          </div>
          <div className={styles.vacancy_list}>
            {vacancy ? (
              <VacancyItem vacancy={vacancy} />
            ) : vacancies.length > 0 ? (
              vacancies.map((vacancy: Vacancy) => (
                <VacancyItem key={vacancy.id} vacancy={vacancy} />
              ))
            ) : (
              <div className={styles.vacancy_empty}>
                <Icon name="eyesIcon" width='40' height='40'></Icon>
                <h4>Сейчас мы&nbsp;никого не&nbsp;ищем</h4>
                <p className='text_body_b2'>При этом мы&nbsp;совсем не&nbsp;против получить резюме хорошего специалиста. Для отправки &mdash; <span className={styles.link} onClick={handleShareLink}>info@vostokstroy.com</span></p>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer theme={FooterType.Light} />
    </>
  )
}
